import { DownOutlined, FormOutlined } from "@ant-design/icons";
import { Dropdown, Input, Menu, Space, Typography, Form } from "antd";
import Table, { ColumnsType, TablePaginationConfig } from "antd/lib/table";
import { AddProductModal, EditProductModal } from "components";
import React, { useEffect, useState } from "react";
import { api } from "services/api";
import { DataModule } from "types";
import "./style.scss";

export const ManageProducts: React.FC = () => {
	const [selectedValue, setSelecteValue] = useState<string>("10");
	const [isOpen, setIsOpen] = useState<boolean>(false);
	const [isOpenEdit, setIsOpenEdit] = useState<boolean>(false);
	const [currentImgURL, setCurrentImgURL] = useState<string>("");
	const [productStatus, setProductStatus] = useState<boolean>(false);
	const [productIsHighlight, setProductIsHighlight] = useState<boolean>(false);
	const [paginationInfo, setPaginationInfo] = useState<TablePaginationConfig>();
	const [totalItensValue, setTotalItensValue] = useState<number>(0);
	const [products, setProducts] = useState<any[]>();
	const [currentProductInfo, setCurrentProductInfo] = useState<any>();
	const [isLoading, setIsLoading] = useState<boolean>(false);
	const [form] = Form.useForm();
	const [editForm] = Form.useForm();
	const menu = (
		<Menu
			selectable
			// @ts-ignore
			onClick={(e) => setSelecteValue(e.key)}
			defaultSelectedKeys={["3"]}
			items={[
				{
					key: "10",
					label: "10",
				},
				{
					key: "20",
					label: "20",
				},
				{
					key: "30",
					label: "30",
				},
				{
					key: "40",
					label: "40",
				},
			]}
		/>
	);

	const getUpdatedInfo = async (id: string) => {
		setIsLoading(true);
		if (products) {
			const {
				data: {
					data: { product },
				},
			} = await api.get(`/products/${id}`);
			setIsLoading(false);
			setCurrentProductInfo(product);
		}
	};

	const columns: ColumnsType<DataModule> = [
		{
			title: "Título do produto",
			dataIndex: "title",
			key: "title",
			render: (text) => <p style={{ margin: 0 }}>{text}</p>,
			onCell: () => {
				return {
					width: "12%",
				};
			},
		},
		{
			title: "Descrição",
			dataIndex: "description",
			key: "description",
		},
		{
			title: "Cadastrado em",
			dataIndex: "created_at",
			key: "created_at",
			render: (text) => <p style={{ margin: 0 }}>{text ? text : "-"}</p>,
			onCell: () => {
				return {
					width: "11%",
				};
			},
		},
		{
			title: "Última edição",
			dataIndex: "updated_at",
			key: "updated_at",
			render: (text) => <p style={{ margin: 0 }}>{text ? text : "-"}</p>,
			onCell: () => {
				return {
					width: "11%",
				};
			},
		},
		{
			title: "Status",
			dataIndex: "status",
			key: "status",
			render: (status) => (
				<p style={{ margin: 0 }}>
					{status === "publish" ? "Publicado" : "Desativado"}
				</p>
			),
		},
		{
			title: "Ativo",
			dataIndex: "is_active",
			key: "is_active",
			render: (active) => (
				<p style={{ margin: 0 }}>{active === true ? "Sim" : "Não"}</p>
			),
		},
		{
			title: "",
			key: "",
			render: (_, record) => (
				<Space size="middle">
					<FormOutlined
						className="edit"
						onClick={async () => {
							await getUpdatedInfo(`${record?.id}`);
							setIsOpenEdit(true);
						}}
					/>
				</Space>
			),
		},
	];

	useEffect(() => {
		setProducts(undefined);
		api
			.get(
				`/products?per_page=${selectedValue}&paginate=true&page=${
					paginationInfo?.current ? paginationInfo.current : 1
				}`
			)
			.then((res) => {
				setProducts(res?.data?.data?.products);
				setTotalItensValue(Number(res?.data?.pagination?.total));
			});
	}, [selectedValue, paginationInfo]);

	return (
		<div className="m-product">
			<AddProductModal
				form={form}
				isOpen={isOpen}
				setIsOpen={setIsOpen}
				currentImgURL={currentImgURL}
				setCurrentImgURL={setCurrentImgURL}
				productStatus={productStatus}
				setProductStatus={setProductStatus}
				productIsHighlight={productIsHighlight}
				setProductIsHighlight={setProductIsHighlight}
				setProducts={setProducts}
			/>
			<EditProductModal
				form={editForm}
				setIsOpen={setIsOpenEdit}
				isOpen={isOpenEdit}
				currentProductInfo={currentProductInfo}
				currentImgURL={currentImgURL}
				setCurrentImgURL={setCurrentImgURL}
				productStatus={productStatus}
				setProductStatus={setProductStatus}
				productIsHighlight={productIsHighlight}
				setProductIsHighlight={setProductIsHighlight}
				setProducts={setProducts}
			/>
			<div className="m-product__container">
				<h1 className="m-product__container__title">Produtos</h1>
				<div className="m-product__container__input">
					<div className="m-product__container__input__user-number">
						Exibir{" "}
						{
							<Dropdown overlay={menu}>
								<Typography.Text>
									{selectedValue}
									<DownOutlined style={{ marginLeft: "5px" }} />
								</Typography.Text>
							</Dropdown>
						}{" "}
						produtos
					</div>
					<Input placeholder="Pesquisar..." />
					<button
						className="m-product__container__input__btn"
						onClick={() => setIsOpen(true)}
					>
						+ Adicionar Produtos
					</button>
				</div>
				<Table
					loading={products === undefined || isLoading}
					columns={columns}
					dataSource={products}
					onChange={(e) => setPaginationInfo(e)}
					pagination={{
						total: totalItensValue,
						showSizeChanger: false,
						pageSize: +selectedValue,
					}}
				/>
			</div>
		</div>
	);
};
